import { RG_TYPE } from "@project-rouge/rg-core";
function getEfficiencyCost(state) {
	const sumGia = state.sequence.reduce((sum$1, a) => sum$1 + a.gia, 0);
	return 1 - state.sequence.reduce((sum$1, a) => sum$1 + getActionNia(a), 0) / sumGia;
}
function getActionNia(action) {
	if (action.unit.type === RG_TYPE.Apartment) return action.unit.data.nia;
	return 0;
}
export { getEfficiencyCost };

//# sourceMappingURL=index147.js.map